<div class="cdh-download-complet-dialog-content">
  <span
    ><h3 class="cdh-download-complete-dialog-title">
      Export Successful!
    </h3></span
  >
  <span
    ><h5 class="cdh-download-complete-dialog-sub-title">
      The customer list has been saved to you device as an XLSX file.
    </h5></span
  >
  <div class="cdh-download-complet-dialog-content-close-button">
    <button epg-button [shape]="'text'" (click)="close()">Close</button>
  </div>
</div>
